const serviceName = '/service/rootstech'
export default serviceName
